

































































































































































































import { Component, Vue } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import FileInput from '@/app/ui/components/FileInput/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import IconDownload from '@/app/ui/assets/icon_download.vue'
import IconWarningTriangle from '@/app/ui/assets/icon_warning_triangles.vue'
import controller from '@/app/ui/controllers/HomepageBannerController'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import {
  required,
  maxLength,
  and,
  or,
  url as urlValidation,
} from 'vuelidate/lib/validators'
import { EventBus, EventBusConstants } from '@/app/infrastructures/misc'
import DateTimePicker from '@/app/ui/components/DateTimePicker/index.vue'
import dayjs from 'dayjs'

interface Form {
  title: string
  image: Blob | File | null
  urlLink: string
  startDate: string
  startTime: string
  endDate: string
  endTime: string
}

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    TextInput,
    FileInput,
    Modal,
    LoadingOverlay,
    DateTimePicker,
    IconDownload,
    IconWarningTriangle
  },
})
export default class CreateHomepageBannerPage extends Vue {
  confirmationModal = false
  successModal = false

  form: Form = {
    title: '',
    image: null,
    urlLink: '',
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
  }

  created(): void {
    EventBus.$on(EventBusConstants.CREATE_HOMEPAGE_BANNER_SUCCESS, () => {
      this.confirmationModal = false
      this.successModal = true
    })
  }

  get isLoading(): boolean {
    return controller.isLoading
  }

  private changeImage(file: File) {
    this.form.image = file
  }

  @Validations()
  validations(): Record<string, any> {
    return {
      form: {
        title: {
          required,
          maxLength: maxLength(70),
        },
        image: {
          required,
        },
        urlLink: {
          url: and(
            required,
            or(urlValidation, (value: string) =>
              value.startsWith('lionparcel://app')
            )
          ),
        },
        startDate: { required },
        endDate: { required },
        startTime: { required },
        endTime: { required },
      },
    }
  }

  private createHomepageBanner() {
    controller.createHomepageBanner({
      title: this.form.title,
      image: this.form.image,
      urlLink: this.form.urlLink,
      startTime: dayjs(`${this.form.startDate} ${this.form.startTime}`).unix(),
      endTime: dayjs(`${this.form.endDate} ${this.form.endTime}`).unix(),
    })
  }

  private onCloseSuccessModal() {
    this.successModal = false
    this.$router.push({ name: 'HomepageBannerList' })
  }

  get today(): string {
    return dayjs().format('YYYY-MM-DD[T]HH:mm:ss.SSS')
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.CREATE_HOMEPAGE_BANNER_SUCCESS)
  }
}
